class TrudoorProductGallery extends HTMLElement {
  constructor() {
    super();

    this.mainSliderOptions = {
      slidesToShow: 1,
      slidesToScroll: 1,
      asNavFor: ".woo-variation-gallery-thumbnail-slider",
      dots: false,
      infinite: false,
      arrows: true,
      adaptiveHeight: false,
      lazyLoad: "ondemand",
    };

    this.thumbnailSliderOptions = {
      slidesToShow: 4,
      slidesToScroll: 4,
      asNavFor: ".woo-variation-gallery-slider",
      dots: false,
      infinite: false,
      arrows: true,
      centerMode: false,
      focusOnSelect: true,
      adaptiveHeight: false,
      vertical: false,
      lazyLoad: "ondemand",
      rtl: false,
      centerPadding: "0px",
      responsive: [
        {
          breakpoint: 767,
          settings: { vertical: true },
        },
        {
          breakpoint: 575,
          settings: { vertical: false },
        },
      ],
    };
  }

  async connectedCallback() {
    try {
      LoadingManager.show({ elementId: this.id });
      await Promise.all([this.initSlickSlider(), this.waitForImages(), this.initPhotoSwipe()]);
    } catch (error) {
      console.error("Error initializing gallery:", error);
    } finally {
      LoadingManager.hide({ elementId: this.id });
    }
  }

  initSlickSlider() {
    return new Promise((resolve, reject) => {
      try {
        const $ = jQuery;
        const mainSlider = $(".woo-variation-gallery-slider");
        const thumbSlider = $(".woo-variation-gallery-thumbnail-slider");

        if (mainSlider.hasClass("slick-initialized")) mainSlider.slick("unslick");
        if (thumbSlider.hasClass("slick-initialized")) thumbSlider.slick("unslick");

        mainSlider.slick(this.mainSliderOptions);

        const thumbCount = $(".wvg-gallery-thumbnail-image").length;
        if (thumbCount > 1) {
          thumbSlider.slick(this.thumbnailSliderOptions);
        }

        $(".main_image_slider, .thumbnail_slider").addClass("loaded");
        resolve();
      } catch (error) {
        reject(error);
      }
    });
  }

  initPhotoSwipe() {
    return new Promise((resolve) => {
      try {
        const $ = jQuery;
        const container = [];
        const mainSliderImages = $(".main_image_slider").find(".wvg-gallery-image");

        // Build container from main slider images (high-res sources)
        mainSliderImages.each(function () {
          const $link = $(this);
          const $img = $link.find("img");
          const rect = $img[0].getBoundingClientRect();

          container.push({
            src: $link.attr("data-src") || $link.attr("href"),
            w: parseInt($link.attr("data-width"), 10) || 1000,
            h: parseInt($link.attr("data-height"), 10) || 1000,
            msrc: $img.attr("src"),
            el: this,
            initialPosition: {
              x: rect.left,
              y: rect.top + window.pageYOffset,
            },
          });
        });

        // Attach PhotoSwipe to main slider image clicks
        $(".main_image_slider a.wvg-gallery-image")
          .off("click.pswp")
          .on("click.pswp", function (event) {
            event.preventDefault();
            event.stopPropagation();

            const pswpElement = document.querySelector(".pswp");
            if (!pswpElement) return;

            // Get the index of the clicked image in the main slider
            const index = $(".main_image_slider .wvg-gallery-image").index(this);

            const options = {
              index: index,
              showHideOpacity: true,
              showAnimationDuration: 333,
              hideAnimationDuration: 333,
              bgOpacity: 0.85,
              spacing: 0.12,
              allowPanToNext: true,
              maxSpreadZoom: 2,
              shareEl: false,
              counterEl: false,
              fullscreenEl: false,
              zoomEl: false,
              captionEl: false,
              loop: true,
              pinchToClose: true,
              tapToToggleControls: true,
              closeOnVerticalDrag: true,
              history: false,
              mouseUsed: false,
              wheelMode: "zoom",
              closeOnScroll: false,
              getThumbBoundsFn: function (index) {
                const $images = $(".main_image_slider .wvg-gallery-image");
                const $targetImage = $images.eq(index);

                if (!$targetImage.length) return null;

                const $img = $targetImage.find("img");
                if (!$img.length) return null;

                const rect = $img[0].getBoundingClientRect();
                return {
                  x: rect.left,
                  y: rect.top + window.pageYOffset,
                  w: rect.width,
                };
              },
            };

            const gallery = new PhotoSwipe(pswpElement, PhotoSwipeUI_Default, container, options);
            gallery.init();
          })
          .css("cursor", "zoom-in");

        resolve();
      } catch (error) {
        console.error("PhotoSwipe initialization error:", error);
        resolve();
      }
    });
  }

  waitForImages() {
    return new Promise((resolve) => {
      const images = jQuery(".main_image_slider").find(".wvg-gallery-image .pswp-img");

      if (!images.length) {
        resolve();
        return;
      }

      let allLoaded = true;
      images.each(function () {
        if (!this.complete) {
          allLoaded = false;
          return false;
        }
      });

      if (allLoaded) {
        resolve();
        return;
      }

      const timeout = setTimeout(() => resolve(), 500);

      let loadedImagesCount = 0;
      const totalImages = images.length;

      images.each(function () {
        if (this.complete) {
          loadedImagesCount++;
        } else {
          jQuery(this).on("load", function () {
            loadedImagesCount++;
            if (loadedImagesCount === totalImages) {
              clearTimeout(timeout);
              resolve();
            }
          });
        }
      });
    });
  }
}

customElements.define("trudoor-product-gallery", TrudoorProductGallery);
